import React from 'react';

import { InboxEmployer, InboxEmployerManager } from 'src/components/inbox';
import { useCurrentUserPermissions } from 'src/hooks/user';

export const InboxPageEmployer: React.FC = () => {
  const { isEmployerManager } = useCurrentUserPermissions();

  if (isEmployerManager) {
    return <InboxEmployerManager />;
  }

  return <InboxEmployer />;
};
